import { forwardRef } from "react";

import {
  TABLE_HEADER_CELL_CLASS_NAME,
  type TTHProps,
} from "@/ui/components/data-display/Table/Table.config";
import { Stack } from "@/ui/components/layout/Stack";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const TH = forwardRef<HTMLTableCellElement, TTHProps>(
  (
    {
      className,
      children,
      icon,
      scope,
      ...props
    },
    ref,
  ) => {
    return (
      <th
        {...props}
        ref={ref}
        scope={scope}
        data-component="TH"
        className={cn(TABLE_HEADER_CELL_CLASS_NAME, className)}
      >
        { icon ? (
          <Stack className="flex items-center gap-2">
            <Icon icon={icon} size="sm" />
            { children }
          </Stack>
        ) : children }
      </th>
    );
  },
);

TH.displayName = "TH";
